import { assetHasQuotation, SIN_COTIZAR } from './quotationAssets';

export const MISSING_USD_QUOTATION_MODAL_TITLE = 'Configurá la cotización del dólar';

export const MISSING_USD_QUOTATION_MODAL_BODY =
  'Para cargar un nuevo aporte necesitás tener configurada la cotización del dólar.';

export function hasUsdQuotationConfigured(saleValue: unknown): boolean {
  if (assetHasQuotation({ saleValue })) return true;
  if (saleValue === SIN_COTIZAR || saleValue == null || saleValue === '') return false;
  const parsed = Number(saleValue);
  return Number.isFinite(parsed) && parsed > 0;
}
